module.exports = "<div *ngIf=\"requiredFieldExist\"><p style=\"color: red; font-size: 10px; float: right; position: absolute;\">\n  {{'global.messages.warning.starredFieldsAreRequired' | translate}}</p>\n<br>\n</div>\n<div *ngIf=\"intakeForm && intakeForm.fields\">\n\n<div *ngFor=\"let field of intakeForm.fields\">\n\n  <!--<rw-intake-field *ngIf=\"!field.isConditional\" [intakeField]=\"field\" ></rw-intake-field>-->\n  <rw-intake-field  [hidden]=\"isFieldHidden(field)\" [intakeField]=\"field\" ></rw-intake-field>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/intake-form/intake-form.component.html
// module id = 1124
// module chunks = 0